import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/new-braunfels")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Awnings New Braunfels & Outdoor Curtains New Braunfels | Texas Awning Company",
      description: "Awnings New Braunfels, outdoor curtains New Braunfels, sail shades, patio & pergola covers, pool cabanas. Texas awning company serving Comal County.",
      image: hero,
      socialTitle: "Awnings New Braunfels & Outdoor Curtains — Texas Made Shade",
      socialDescription: "Awnings New Braunfels + outdoor curtains New Braunfels. Texas awning company building welded aluminum + Sunbrella canvas shade for Comal County.",
      keywords: "awnings New Braunfels, outdoor curtains New Braunfels, awning company New Braunfels, Texas awning company, custom awnings New Braunfels, commercial awnings New Braunfels, commercial awnings Texas, residential awnings New Braunfels, sail shades New Braunfels, patio covers New Braunfels, pergola covers New Braunfels, metal awnings New Braunfels, canvas awnings New Braunfels, Texas Made Shade",

    }),
    scripts: cityHeadScripts("New Braunfels", "Comal County"),
  }),
  component: () => <CityHomePage city="New Braunfels" region="Comal County" />,
});
